module.exports = __webpack_public_path__ + "img/min_ticket.d150eb21.svg";